import React from 'react';
import { Row, Col, Card, Container } from 'reactstrap';
import DisclaimerFooter from './DisclaimerFooter';
// Lead1's own: the light wordmark the dark header already uses, on the dark
// panel, and the mascot the authentication screens have always shown.
import logoLight from '../../assets/images/logo-light.png';
import heroImg from '../../assets/images/hero.png';

// The three lines are the pitch, in order: the agent never leaves a lead
// waiting, the call center takes the conversation when a voice is worth
// more than a message, and the two together are what moves the numbers.
// Nothing here is a claim the platform does not already carry out.
const SKILLS = [
  {
    icon: 'bx bx-bot',
    title: 'No lead left waiting',
    text: 'The agent answers in seconds, at any hour of any day.',
  },
  {
    icon: 'bx bx-user-voice',
    title: 'A person at the right moment',
    text: 'The call center picks up warm, with the whole conversation in hand.',
  },
  {
    icon: 'bx bx-trending-up',
    title: 'More contacts, better conversions',
    text: 'Reach from the agents, quality from the people, counted in one CRM.',
  },
];

// The shell the three authentication screens share: the agent panel beside
// the form. Only the title, the subtitle, the form itself and the line under
// the card change from screen to screen, so only those are props.
const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="auth-page">
    <Container>
      <Row className="justify-content-center">
        <Col lg={11} xl={10}>
          <Card className="auth-card overflow-hidden mb-0">
            <Row noGutters>
              {/* On a phone the panel keeps the brand, the badge and the
                  headline and drops the rest: a strip above the form, not
                  half a screen the thumb has to scroll past. */}
              <Col lg={6}>
                <div className="auth-panel">
                  <div className="auth-panel-content">
                    <img
                      src={logoLight}
                      alt="Lead1"
                      className="auth-panel-logo"
                    />
                    <span className="auth-badge mt-4">
                      <span className="auth-badge-dot"></span>
                      AI agents + call center, one team
                    </span>
                    <h3 className="auth-panel-title mt-3 mb-0 mb-lg-2">
                      AI at scale. People where it counts.
                    </h3>
                    <p className="d-none d-lg-block mb-0">
                      The agents cover every lead around the clock. The call
                      center steps in the moment a human voice changes the
                      outcome.
                    </p>
                    <ul className="auth-skills d-none d-lg-block mt-5 mb-0">
                      {SKILLS.map((skill) => (
                        <li className="auth-skill" key={skill.title}>
                          <span className="auth-skill-icon">
                            <i className={skill.icon}></i>
                          </span>
                          <div>
                            <h6 className="auth-skill-title">{skill.title}</h6>
                            <p className="auth-skill-text font-size-12 mb-0">
                              {skill.text}
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="auth-form">
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div>
                      <h4 className="mb-1">{title}</h4>
                      <p className="text-muted mb-0">{subtitle}</p>
                    </div>
                    <img
                      src={heroImg}
                      alt=""
                      className="auth-form-hero d-none d-sm-block ml-3"
                    />
                  </div>
                  {children}
                </div>
              </Col>
            </Row>
          </Card>
          <div className="text-center text-muted mt-4">
            {footer}
            <DisclaimerFooter />
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

export default AuthShell;
